



























































import { Prop, Component, Vue, Watch } from "vue-property-decorator";
import _ from "lodash";
import { Staff, Company } from "@/api/company-api";
import companyType from "@/helpers/companyType";

import VInvite from "@/components/VInvite.vue";

// TODO: 扱いやすいように整理する
export class StaffTableItem {
  id: number;
  name: string;
  tel: {
    staff: Staff;
    tel: string;
  };
  mail: {
    staff: Staff;
    mail: string;
  };
  companyType: string;
  companyName: string;
  invitable: boolean;
  title: {
    staff: Staff;
    name: string;
  };
  invite: {
    invitable: boolean;
    staff: Staff;
  };
  belongsTo: {
    type: string;
    name: string;
  };
  isHiddenInfo: number;
  scheduleNotification: boolean;

  public constructor(s: Staff, c?: Company, invitable: boolean = false) {
    this.id = s.staffId;
    this.name = s.name;
    this.tel = {
      staff: s,
      tel: s.tel
    };
    this.mail = {
      staff: s,
      mail: s.mail
    };
    if (c) {
      this.companyType = companyType(c);
      this.companyName = c.name;
    } else {
      this.companyType = "";
      this.companyName = "";
    }
    this.invitable = invitable;
    this.title = {
      staff: s,
      name: s.name
    };
    this.invite = {
      invitable,
      staff: s
    };
    this.belongsTo = {
      type: this.companyType,
      name: this.companyName
    };
    this.isHiddenInfo = s.isHiddenInfo;
    this.scheduleNotification = s.scheduleNotification;
  }
}

@Component({
  components: {
    VInvite
  }
})
export default class VStaffTable extends Vue {
  @Prop({ default: () => [] }) items!: StaffTableItem[];
  @Prop({ type: Boolean, default: false }) noCompany!: boolean;
  @Prop({ type: Boolean, default: false }) noInvite!: boolean;
  @Prop({ type: Boolean, default: false }) isCompanyShow!: boolean;

  data: StaffTableItem[] = [];

  baseFields = {
    title: {
      label: "名前",
      sortable: true
    },
    scheduleNotification: {
      label: "チャット通知"
    },
    tel: {
      label: "携帯電話",
      sortable: true
    },
    mail: {
      label: "メール",
      sortable: true
    },
    belongsTo: {
      label: "会社名",
      sortable: true
    },
    invite: {
      label: ""
    }
  };

  get fields() {
    const keys = ["title", "scheduleNotification", "tel", "mail"];
    if (!this.$props.noCompany) {
      keys.push("belongsTo");
    }
    if (!this.$props.noInvite) {
      keys.push("invite");
    }
    return _.pick(this.baseFields, keys);
  }

  @Watch("items")
  changeValue(newValue: StaffTableItem[]) {
    this.handleFilterData(newValue);
  }

  created() {
    setTimeout(() => {
      this.handleFilterData(this.items);
    }, 2500);
  }

  // custom class for tbody tr
  setTbodyTrClass(item: any) {
    const classes = [];
    if (item.isHiddenInfo === 1) classes.push("table-secondary");
    return classes;
  }

  handleFilterData(value: StaffTableItem[]) {
    const listStaff = value.filter(item => item.isHiddenInfo === 0);
    const listStaffHidden = value.filter(item => item.isHiddenInfo === 1);
    this.data = listStaff.concat(listStaffHidden);
  }

  handleInvite(id: number) {
    this.$emit("invite", id);
    this.handleFilterData(this.data);
  }
}
